<template>
  <div class="app-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-document"></i> IC卡管理</span>
      </div>

      <!-- 按钮区：独立一行 -->
      <el-row style="margin-bottom: 20px">
          <el-button type="primary" @click="openAddDialog">
          新增
        </el-button>
        <el-button type="success" @click="downloadTemplate">
          模版下载
        </el-button>
        <el-button type="warning" @click="openImportDialog">
          批量导入
        </el-button>
      </el-row>

      <!-- 表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="cardNo" label="IC卡号"></el-table-column>
        <el-table-column prop="mac" label="MAC"></el-table-column>
        <!-- <el-table-column prop="state" label="状态"></el-table-column> -->
        <el-table-column prop="state" label="状态">
          <template slot-scope="scope">
            <el-tag :type="scope.row.state === 1 ? 'success' : 'info'">
              {{ formatState(scope.row.state) }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="danger"
              size="mini"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />
    </el-card>

        <!-- 新增弹窗 -->
    <el-dialog
      title="新增IC卡"
      :visible.sync="addDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form 
        :model="addForm" 
        ref="addFormRef" 
        label-width="80px"
        :rules="addFormRules"
      >
        <el-form-item label="IC卡号" prop="cardNo">
          <el-input v-model="addForm.cardNo" placeholder="请输入IC卡号"></el-input>
        </el-form-item>
        <el-form-item label="MAC" prop="mac">
          <el-input v-model="addForm.mac" placeholder="请输入MAC地址"></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="addDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAddForm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 批量导入弹窗 -->
    <el-dialog
      title="批量导入"
      :visible.sync="importDialogVisible"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form :model="importForm" ref="importFormRef" label-width="80px">
        <el-form-item label="选择文件">
          <el-upload
            :headers="uploadHeaders"
            :action="UPLOAD_URL"
            :auto-upload="false"
            :on-change="handleFileChange"
            :before-upload="beforeUpload"
            :http-request="customUpload"
            :file-list="fileList"
            accept=".xlsx, .xls"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选取文件</el-button
            >
            <div slot="tip" class="el-upload__tip">
              只能上传xlsx/xls文件，且不超过10MB
            </div>
          </el-upload>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="importData">导入</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  cardPage,
  ICDownloadTemplate,
  cardDelete,
  cardImport,
  cardAdd
} from "@/api/staff";
import { formatState, downloadFile, parseDateRange } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";
import { UPLOAD_URL } from "@/utils/const";
import { getToken } from "@/utils/auth";

export default {
  name: "LeaveApproval",
  components: { PaginationBar },
  data() {
    return {
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      isEdit: false, // 是否为编辑状态
      form: {
        name: "",
      },
      dialogVisible: false,
      dialogTitle: "",
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 表格数据
      tableData: [],
      importDialogVisible: false,
      importForm: {},
      fileList: [],
      importFile: null,
      addDialogVisible: false,
       addForm: {
        cardNo: '',
        mac: ''
      },
      addFormRules: {
        cardNo: [
          { required: true, message: '请输入IC卡号', trigger: 'blur' }
        ],
        mac: [
          { required: true, message: '请输入MAC地址', trigger: 'blur' }
        ]
      },
    };
  },
  created() {
    this.handleQuery(1);
  },
  methods: {
        // 打开新增弹窗
    openAddDialog() {
      this.addDialogVisible = true;
      this.addForm = {
        cardNo: '',
        mac: ''
      };
      this.$nextTick(() => {
        this.$refs.addFormRef && this.$refs.addFormRef.clearValidate();
      });
    },
    
    // 提交新增表单
    submitAddForm() {
      this.$refs.addFormRef.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: "正在保存...",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          
          cardAdd(this.addForm)
            .then(() => {
              loading.close();
              this.$message.success("新增成功");
              this.addDialogVisible = false;
              this.currentPage = 1
              this.handleQuery();
            })
            .catch((error) => {
              loading.close();
              this.$message.error("新增失败: " + (error.message || "未知错误"));
            });
        }
      });
    },
    // 上传前验证
    beforeUpload(file) {
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName
        .substring(fileName.lastIndexOf("."))
        .toLowerCase();

      // 验证文件类型
      const validExtensions = [".xlsx", ".xls"];

      if (!validExtensions.includes(fileExtension)) {
        this.$message.error("只能上传Excel格式的文件（.xlsx 或 .xls）");
        return false;
      }

      // 验证文件大小（10MB限制）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过10MB");
        return false;
      }

      return true;
    },
    // 自定义上传方法（不实际上传）
    customUpload() {
      // 空实现，因为我们不希望自动上传
      return false;
    },
    handleFileChange(file, fileList) {
      // 验证文件类型
      const isValid = this.beforeUpload(file);
      if (!isValid) {
        // 如果验证不通过，清除文件列表
        this.$refs.upload.clearFiles();
        return false;
      }

      this.importFile = file.raw;
      this.fileList = fileList;
    },
    // 导入数据
    importData() {
      if (!this.importFile) {
        this.$message.warning("请选择要导入的文件");
        return;
      }

      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: "正在导入数据...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 创建 FormData 对象
      const formData = new FormData();
      formData.append("file", this.importFile);

      // 调用导入API
      cardImport(formData)
        .then(() => {
          loading.close();
          this.$message.success("导入成功");
          this.importDialogVisible = false;
          this.handleQuery(this.currentPage);
        })
        .catch((error) => {
          loading.close();
          this.$message.error("导入失败: " + (error.message || "未知错误"));
        });
    },
    // 打开导入弹窗
    openImportDialog() {
      this.importDialogVisible = true;
      this.fileList = [];
      this.importFile = null;
    },
    formatState(state) {
      const stateMap = {
        0: "未绑定",
        1: "已绑定",
      };
      return stateMap[state] || "未知状态";
    },
    // 下载模板
    downloadTemplate() {
      ICDownloadTemplate().then((res) => {
        downloadFile(res.data, "IC卡导入模板.xlsx");
      });
    },
    // 删除按钮点击事件
    handleDelete(row) {
      if (!row || !row.id) {
        return this.$message.success("当前数据无效，无法删除");
      }
      this.$confirm("确定要删除当前ic卡？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 这里调用删除API
          cardDelete({
            id: row.id,
          }).then(() => {
            this.$message.success("删除成功");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {
          // 取消删除
        });
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      cardPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    // 重置搜索
    resetQuery() {
      this.handleQuery(1);
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
  .el-icon-document {
    margin-right: 5px;
    font-size: 18px;
  }

  .el-table {
    .el-icon-user,
    .el-icon-office-building,
    .el-icon-document,
    .el-icon-time,
    .el-icon-date,
    .el-icon-notebook-2 {
      margin-right: 5px;
    }
  }

  .el-tag {
    .el-icon-check,
    .el-icon-loading,
    .el-icon-close {
      margin-right: 5px;
    }
  }

  .el-button {
    .el-icon-edit,
    .el-icon-delete,
    .el-icon-plus,
    .el-icon-close,
    .el-icon-check {
      margin-right: 5px;
    }
  }

  .el-select {
    .el-icon-document,
    .el-icon-first-aid-kit,
    .el-icon-date,
    .el-icon-time {
      margin-right: 5px;
    }
  }

  .demo-form-inline {
    .el-form-item {
      margin-bottom: 10px;
    }
  }

  .search-buttons {
    margin-bottom: 20px;

    .el-button {
      margin: 0 10px;
    }
  }
}
.el-table__content {
  overflow-x: auto;
}
.el-table {
  &__header-wrapper {
    th {
      background-color: #f5f7fa !important;
      color: #333;
      font-weight: bold;
    }
  }

  &--border,
  &--group {
    border: 1px solid #dcdfe6;
  }

  .cell {
    white-space: nowrap;
  }
}
</style>
